<ng-container
  *ngIf="
    (userInfo.isAdmin || (featureFlags$ | async)?.importExportBookmarks) &&
    newstype === 'Bookmarked'
  "
>
  <div
    class="floating-actions show"
    [class.float-more2]="newsfeed && newsfeed.length !== 0"
  >
    <mat-icon
      matTooltip="Import bookmarks"
      svgIcon="tray-arrow-up"
      (click)="fileInputBookmarks.click()"
    ></mat-icon>
    <input
      #fileInputBookmarks
      class="inptfile"
      type="file"
      accept=".json"
      value=""
      (click)="fileInputBookmarks.value = ''"
      (change)="importBookmarkedArticles($event)"
      multiple
    />
  </div>

  <div
    class="floating-actions float-more show"
    *ngIf="newsfeed && newsfeed.length !== 0"
  >
    <mat-icon
      (click)="exportBookmarkedArticles(newsfeed)"
      matTooltip="Export bookmarks"
      svgIcon="tray-arrow-down"
    ></mat-icon>
  </div>
</ng-container>
